import { Block, CRRender, Inline } from '@/components/crRender'
import { translate } from '@/utils/langUtils'
import OptionalServices from '../OptionalServices'
import { Icon } from '@iconify/react/dist/iconify.js'
import moment from 'moment'
// import DatePickerC from '@/components/formFields/DatePicker'
import useForm from '@/hooks/useForm'
import DatePickerr from '@/components/formFields/DatePicker/DataPickerr'

const QuotationInfo = ({ quotationData, setScheduledDate, selectedAddOns, selectedPostServices, scheduledDate, ToggleCheckBox, setSelectedAddOns, setSelectedPostServices }) => {
   
   const {formHandler} = useForm()
    return (
        <div className="qd-left-column">
            <div className="qd-card">
                <h2 className="qd-card-title">
                    {translate("Quotation Details for")} {quotationData?.serviceName}
                </h2>

                <div className="qd-details-row">
                    <div className="qd-detail-item">
                        <div className="qd-detail-label">{translate("Base Quotation")}</div>
                        <div className="qd-detail-description">
                            {translate("Includes standard procedure and hospital stay.")}
                        </div>
                        <div className="qd-detail-value">${quotationData?.price}</div>
                    </div>

                    <div className="qd-detail-item">
                        <div className="qd-detail-label">
                            <Icon icon="solar:calendar-date-bold" className="qd-icon" />
                            {translate("Scheduled Date")}
                        </div>
                        <div className="qd-detail-description">{translate("Proposed treatment date.")}</div>
                        <div className="qd-detail-value">
                            <CRRender isRender={!quotationData?.patientSelectedDate}>
                                <DatePickerr
                                    formHandler={formHandler}
                                    className='col-md-12'
                                    name="scheduledDate"
                                    showLabel={false}
                                    isSingle
                                    defaultValue={scheduledDate || undefined}
                                    minDate={moment(quotationData?.availableFromDate).toDate()}
                                    maxDate={moment(quotationData?.availableToDate).toDate()}
                                    onApply={date => {
                                        console.log("date from picker", date)
                                        setScheduledDate(date as Date)}} />
                            </CRRender>
                            <Block isRender={!!scheduledDate || !!quotationData?.patientSelectedDate} className="qd-detail-value-container">
                                <span className="qd-detail-value-label">{translate("prefered date to  do operation")}</span> {" "}
                                <span className="qd-detail-value-value">{moment(scheduledDate || quotationData?.patientSelectedDate).format("YYYY-MM-DD")}</span>
                            </Block>
                            <Inline isRender={!scheduledDate && !quotationData?.patientSelectedDate} >{translate("Select your preferred date")}</Inline>
                        </div>
                    </div>
                </div>

                <div className="qd-section">
                    <h3 className="qd-section-title">{translate("Included in your package:")}</h3>
                    <ul className="qd-list  inlcudes-packages">
                        {quotationData?.packages?.map((service, index) => (
                            <li key={index}>{service}</li>
                        ))}
                    </ul>
                </div>

                <OptionalServices ServicesList={quotationData?.addOns} title={"Optional Add-ons"} selectedItems={selectedAddOns} handleToggle={id => ToggleCheckBox(setSelectedAddOns, id)} />

                <OptionalServices ServicesList={quotationData?.postServices} title={"Supposed-postServices"} selectedItems={selectedPostServices} handleToggle={id => ToggleCheckBox(setSelectedPostServices, id)} />

            </div>

            {/* Refund Policy and Payment Terms */}
            <div className="qd-policies-row">
                <div className="qd-policy-card">
                    <h3 className="qd-policy-title">{translate("Payment Terms")}</h3>
                    <ul className="qd-policy-list">
                        {quotationData?.paymentTerms}
                    </ul>
                </div>
{/* 
                <div className="qd-policy-card">
                    <h3 className="qd-policy-title">{translate("Refund Policy")}</h3>
                    <p className="qd-policy-list">
                        {quotationData?.refundPolicy}
                    </p>
                </div>
                 */}

            </div>
        </div>
    )
}

export default QuotationInfo
